import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards";

export default function ResidencyInvestmentUAE() {

    return (
        <main className='main'>

            <IntroSection
                title="Residency & Investment – UAE"
                subtitle="Secure Your Future in the Middle East’s Leading Hub"
                description="The UAE Residency by Investment Programs allow entrepreneurs and investors to obtain long-term visas while enjoying 0% personal tax, global banking access, and world-class infrastructure. With options like Free Zone company ownership, real estate purchases, and the UAE Golden Visa, investors can establish themselves in Dubai, Abu Dhabi, or other Emirates."
                badges={[
                    "Residency Visas",
                    "Golden Visa Options",
                    "0% Personal Tax",
                    "Family Sponsorship"
                ]}
                buttonText="Request a UAE Residency Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../assets/images/residency-passport/residency-investment-uae-hero.png")}
                imageAlt="UAE Residency & Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose UAE Residency?'
                        blocks={[
                            {
                                items: [
                                    { title: "Tax-Free Lifestyle", text: "0% personal income tax and no capital gains tax." },
                                    { title: "Residency by Investment", text: "Obtain residency through company formation, property purchase, or Golden Visa." },
                                    { title: "Banking & Business Access", text: "Easily open corporate and personal bank accounts in the UAE." },
                                    { title: "Family Friendly", text: "Sponsor spouse, children, and parents under one residency structure." },
                                    { title: "Global Mobility", text: "UAE residency enhances credibility for global travel and business." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency Pathways"
                        blocks={[
                            {
                                title: "1. company-formation Residency",
                                items: [
                                    { text: "Register a Mainland, Free Zone, or Offshore entity." },
                                    { text: "Residency visas available for shareholders and employees." },
                                    { text: "Fast-track business residency ideal for entrepreneurs." }
                                ]
                            },
                            {
                                title: "2. Real Estate Investment Residency",
                                items: [
                                    { text: "Purchase property valued at AED 750,000+ (~USD 200,000)." },
                                    { text: "Residency visa renewable every 2 years for property owners." }
                                ]
                            },
                            {
                                title: "3. UAE Golden Visa (5–10 Years)",
                                items: [
                                    { text: "Available for investors, entrepreneurs, and skilled professionals." },
                                    { text: "Real estate investment from AED 2 million+ (~USD 545,000)." },
                                    { text: "Long-term residency with no local sponsor required." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='Key Features of UAE Residency'
                        blocks={[
                            {
                                items: [
                                    { title: "Long-Term Visas", text: "Residency options range from 2, 5, to 10 years." },
                                    { title: "Tax-Free Environment", text: "No personal income tax or capital gains tax." },
                                    { title: "Family Sponsorship", text: "Sponsor spouse, children, and even parents." },
                                    { title: "Full Access to UAE Systems", text: "Healthcare, education, banking, and utilities access." },
                                    { title: "Flexible Re-Entry", text: "Multiple entries and renewals permitted." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='Benefits of UAE Residency by Investment'
                        blocks={[
                            {
                                items: [
                                    { title: "Business Gateway", text: "Strategically located between Asia, Europe, and Africa." },
                                    { title: "Flexible Investment Routes", text: "Company formation, real estate, or long-term Golden Visa options." },
                                    { title: "Wealth Planning", text: "Tax-free income and favourable wealth management environment." },
                                    { title: "Lifestyle Benefits", text: "High quality of life, safety, luxury infrastructure." },
                                    { title: "Golden Visa Security", text: "5–10 year residency without a sponsor." }
                                ]
                            }
                        ]}
                    />

                    <DetailsSection
                        title="Process to Apply for UAE Residency"
                        items={[
                            { text: "Consultation & Eligibility Check" },
                            { text: "Choose Pathway — company formation, real estate, or Golden Visa" },
                            { text: "Document Preparation & Filing — company docs, property deeds, or capital proof" },
                            { text: "Medical Check & Emirates ID Application" },
                            { text: "Residency Permit Issued — 2, 5, or 10 years depending on route" }
                        ]

                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "2–6 weeks",
                            },
                            {
                                name: "Investment Thresholds",
                                description: "AED 750,000–2,000,000+",
                            },
                            {
                                name: "Additional Costs",
                                description: "Visa fees, medical test, Emirates ID, service charges",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in UAE residency, company formation & Golden Visa programs" },
                                { text: "Network across Dubai, Abu Dhabi, RAK, Sharjah" },
                                { text: "Full support: incorporation, property, visas, and renewals" },
                                { text: "Comparative insights: UAE vs Cyprus vs Malta vs Singapore" },
                                { text: "Tailored residency planning for families and entrepreneurs" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for tax-free residency in a global hub?"
                        description="The UAE Residency & Golden Visa programs provide long-term security, family inclusion, and business opportunities."
                        buttonText="Book a UAE Residency Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can I get UAE residency through property?",
        content: [
            { type: "answer", text: "Yes — properties worth AED 750,000+ qualify for residency visas." },
        ],
    },
    {
        question: "What is the UAE Golden Visa?",
        content: [
            { type: "answer", text: "A 5–10 year residency permit available for investors, entrepreneurs, professionals, and talented individuals." },
        ],
    },
    {
        question: "Do UAE residents pay tax?",
        content: [
            { type: "answer", text: "No — there is no personal income tax." },
        ],
    },
    {
        question: "Can my family join me?",
        content: [
            { type: "answer", text: "Yes — spouses, children, and parents can be sponsored." },
        ],
    },
    {
        question: "How long does the process take?",
        content: [
            { type: "answer", text: "Typically 2–6 weeks." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We secured UAE residency by setting up a Dubai Free Zone company. Offshore Advisory made the process seamless.",
        author: "Hassan A.",
        role: "Entrepreneur"
    },
    {
        quote: "The UAE Golden Visa gave my family long-term residency security. Offshore Advisory managed the property investment and application.",
        author: "Maria D.",
        role: "Investor"
    }
];
